import styled, { css } from 'styled-components';
import { ReactComponent as Shield } from '../../../assets/img/shield.svg';
import { fontUi } from '../../../theme/typography';

const ownWash = css`
  background: ${({ theme }) =>
    theme.isDark ? 'rgba(14, 74, 251, 0.24)' : 'rgba(14, 74, 251, 0.12)'};
`;

export const StyledGroupContainer = styled.div`
  display: flex;
  flex-direction: row;
  max-width: 250px;
  align-items: center;
  border-radius: 6px;
  height: 28px;
  width: 100%;
  justify-content: flex-end;
  position: relative;
  ${({ $own }) => $own && ownWash};
  ${({ side }) => {
    if (side === 'right') {
      return css`
        flex-direction: row-reverse;
      `;
    }
  }}
  ${({ cardPosition }) => {
    if (cardPosition === 'first') {
      return css`
        margin-bottom: 20px;
      `;
    }
  }}
  ${({ shortVersion }) => {
    if (shortVersion) {
      return css`
        border: 0;
        max-width: 90px;
        margin-bottom: 0;
      `;
    }
  }}
`;
export const StyledName = styled.div`
  display: flex;
  flex-direction: row;
  ${fontUi};
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme }) => theme.text};
  align-items: center;
  width: 150px;
  height: 100%;
  padding-right: 10px;
  cursor: pointer;
  justify-content: flex-end;
  span {
    padding-right: 10px;
    text-align: right;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  ${({ side }) => {
    if (side === 'right') {
      return css`
        flex-direction: row-reverse;
        padding-left: 10px;
        span {
          padding-left: 10px;
          text-align: left;
        }
      `;
    }
  }}
  img {
    max-width: 22px;
    max-height: 22px;
    width: 100%;
    height: 100%;
    object-fit: contain;
    flex-shrink: 0;
  }

  ${({ shortVersion }) => {
    if (shortVersion) {
      return css`
        width: 30px;
        background-color: transparent;
      `;
    }
  }}
`;
export const StyledGoals = styled.div`
  ${fontUi};
  width: 23px;
  font-size: 11px;
  font-weight: 700;
  background-color: ${({ theme }) => theme.inset};
  color: ${({ theme }) => theme.text};
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 6px;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  ${({ side }) => {
    if (side === 'right') {
      return css`
        flex-direction: row-reverse;
      `;
    }
  }}
  ${({ $pending, theme }) => {
    if ($pending) {
      return css`
        color: ${theme.textFaint};
        font-weight: 500;
      `;
    }
  }}
  ${({ shortVersion }) => {
    if (shortVersion) {
      return css`
        margin-left: 10px;
      `;
    }
  }}
`;

export const StyledNoWinner = styled(Shield)`
  width: 22px;
  flex-shrink: 0;
  path {
    fill: ${({ theme }) => theme.border};
  }
`;

export const StyledNotAvailable = styled.span`
  ${fontUi};
  color: ${({ theme }) => theme.textFaint};
  font-size: 12px;
`;
